/** ***********
*
* <user-right.action.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*  NG6C740 [thomas.pereira.external@airbus.com]
*
* All rights reserved.
**************/

import { createAction, props } from '@ngrx/store';
import { FamilyRight, ParentFamilyRight } from 'src/app/models/family';
import { User } from 'src/app/models/user';
import {
    DeleteMyRightsPayload,
    FamilyManagers,
    Group,
    GroupFamily,
    Option,
    RequestAGroup,
    RightRequest,
    SendGroupRequest,
    SpecificRoleDialogData,
    UpdateRightActionPayload,
} from 'src/app/models/user-right';
import { GroupCreate, GroupUpdate } from 'src/app/services/user-right.service';


export enum ActionTypes {
    LOAD_MY_RIGHT_TREE = '[UserRight] Load my right tree',
    FETCH_MY_RIGHT_TREE = '[UserRight] Fetch my right tree',
    SUCCESS_USER_RIGHT_TREE = '[UserRight] Success user rights tree',
    SUCCESS_MY_RIGHTS_TREE = '[UserRight] Success my rights tree',
    UPDATE_MY_RIGHTS_TREE_REQUESTS_MAPPING = '[UserRight] Success my rights tree requests mapping',
    ERROR_MY_RIGHT_TREE = '[UserRight] Error my right tree',
    SUCCESS_MANAGERS = '[UserRight] Success managers',
    SUCCESS_RIGHT_REQUEST = '[UserRight] Success right request',
    CREATE_RIGHT_REQUEST = '[UserRight] create right request',
    DELETE_RIGHT_REQUEST = '[UserRight] Delete right request',
    ERROR_RIGHT_REQUEST = '[UserRight] Error Right request',
    SUCCESS_UPDATE_RIGHT = '[UserRight] Update Right',
    ERROR_UPDATE_RIGHT = '[UserRight] Error Right',
    SUCCESS_ALL_USERS = '[UserRight] Success all users',
    SUCCESS_UPDATE_SPECIFIC_ROLE = '[UserRight] Success Update specific role',
    UPDATE_SPECIFIC_ROLE = '[UserRight] Update specific role',
    ERROR_UPDATE_SPECIFIC_ROLE = '[UserRight] Error Update specific role',
    FETCH_GROUPS = '[UserRight] Fetch groups',
    SUCCESS_FETCH_GROUPS = '[UserRight] Success fetch groups',
    ERROR_FETCH_GROUPS = '[UserRight] Error fetch groups',
    UPDATE_GROUP = '[UserRight] Update group',
    SUCCESS_UPDATE_GROUP = '[UserRight] Success update group',
    ERROR_UPDATE_GROUP = '[UserRight] Error update group',
    TRANSFER_GROUP_OWNERSHIP = '[UserRight] Transfer group ownership',
    SUCCESS_TRANSFER_GROUP_OWNERSHIP = '[UserRight] Success transfer group ownership',
    ERROR_TRANSFER_GROUP_OWNERSHIP = '[UserRight] Error transfer group ownership',
    CREATE_GROUP = '[UserRight] Create group',
    SUCCESS_CREATE_GROUP = '[UserRight] Success create group',
    ERROR_CREATE_GROUP = '[UserRight] Error create group',
    DELETE_GROUP = '[UserRight] Delete group',
    SUCCESS_DELETE_GROUP = '[UserRight] Success delete group',
    ERROR_DELETE_GROUP = '[UserRight] Error delete group',
    FETCH_USERS_OF_GROUP = '[UserRight] Fetch users of group',
    SUCCESS_FETCH_USERS_OF_GROUP = '[UserRight] Success fetch users of group',
    ERROR_FETCH_USERS_OF_GROUP = '[UserRight] Error fetch users of group',
    FETCH_FAMILIES_OF_GROUP = '[UserRight] Fetch families of group',
    SUCCESS_FETCH_FAMILIES_OF_GROUP = '[UserRight] Success fetch families of group',
    ERROR_FETCH_FAMILIES_OF_GROUP = '[UserRight] Error fetch families of group',
    ADD_USERS_TO_GROUP = '[UserRight] Add users to group',
    SUCCESS_ADD_USERS_TO_GROUP = '[UserRight] Success add users to group',
    ERROR_ADD_USERS_TO_GROUP = '[UserRight] Error add users to group',
    ADD_FAMILIES_TO_GROUP = '[UserRight] Add families to group',
    SUCCESS_ADD_FAMILIES_TO_GROUP = '[UserRight] Success add families to group',
    ERROR_ADD_FAMILIES_TO_GROUP = '[UserRight] Error add families to group',
    CHANGE_GROUP_FAMILIES_LEVEL = '[UserRight] Change levels of families of a group',
    SUCCESS_CHANGE_GROUP_FAMILIES_LEVEL = '[UserRight] Success change levels of families of a group',
    ERROR_CHANGE_GROUP_FAMILIES_LEVEL = '[UserRight] Error change levels of families of a group',
    REMOVE_USERS_FROM_GROUP = '[UserRight] Remove users from group',
    DELETE_MY_RIGHT = '[UserRight] Remove my rights',
    SUCCESS_REMOVE_USERS_FROM_GROUP = '[UserRight] Success remove users from group',
    SUCCESS_DELETE_MY_RIGHT = '[UserRight] Success remove right',
    ERROR_REMOVE_USERS_FROM_GROUP = '[UserRight] Error remove users from group',
    REMOVE_FAMILIES_FROM_GROUP = '[UserRight] Remove families from group',
    SUCCESS_REMOVE_FAMILIES_FROM_GROUP = '[UserRight] Success remove families from group',
    ERROR_REMOVE_FAMILIES_FROM_GROUP = '[UserRight] Error remove families from group',
    FETCH_GROUPS_OF_USER = '[UserRight] Fetch groups of user',
    SUCCESS_FETCH_GROUPS_OF_USER = '[UserRight] Success fetch groups of user',
    ERROR_FETCH_GROUPS_OF_USER = '[UserRight] Error fetch groups of user',
    FETCH_LIST_OF_ALL_GROUPS = '[UserRight] Fetch list of all Groups',
    SUCCESS_FETCH_LIST_OF_ALL_GROUPS = '[UserRight] Success Fetch list of all groups',
    ERROR_FETCH_LIST_OF_ALL_GROUPS = '[UserRight] Error Fetch list of all groups',
    RAISE_GROUP_REQUEST = '[UserRight] Raise Group Request',
    SUCCESS_RAISE_GROUP_REQUEST = '[UserRight] Success Requested Group',
    ERROR_RAISE_GROUP_REQUEST = '[UserRight] Error Create Group Request',
    CANCEL_GROUP_REQUEST = '[UserRight] Cancel a group request',
    SUCCESS_CANCEL_GROUP_REQUEST = '[UserRight] Success Cancel a group request',
    ERROR_CANCEL_GROUP_REQUEST = '[UserRight] Error Cancel a group request'
}

export class LoadParentFamilyRight {
    readonly type = ActionTypes.LOAD_MY_RIGHT_TREE;
}

export class FetchMyRightsTree {
    readonly type = ActionTypes.FETCH_MY_RIGHT_TREE;
}

export class SuccessMyRightsTree {
    readonly type = ActionTypes.SUCCESS_MY_RIGHTS_TREE;
    constructor(public parentFamiliesRights: ParentFamilyRight[], public familiesRigths: FamilyRight[]) { }
}

export class UpdateMyRightsTreeRequestsMapping {
    readonly type = ActionTypes.UPDATE_MY_RIGHTS_TREE_REQUESTS_MAPPING;
    constructor(public payload: RightRequest[]) { }
}

export class SuccessUserRightTree {
    readonly type = ActionTypes.SUCCESS_USER_RIGHT_TREE;
    constructor(public parentsRights: ParentFamilyRight[], public familiesRights: FamilyRight[]) {
    }
}

export class ErrorParentFamilyRight {
    readonly type = ActionTypes.ERROR_MY_RIGHT_TREE;
}

export class SuccessUpdateRight {
    readonly type = ActionTypes.SUCCESS_UPDATE_RIGHT;
    constructor(public payload: UpdateRightActionPayload[]) { }
}

export class ErrorUpdateRight {
    readonly type = ActionTypes.ERROR_UPDATE_RIGHT;
}

export class SuccessManagers {
    readonly type = ActionTypes.SUCCESS_MANAGERS;
    constructor(public payload: FamilyManagers) { }
}

export class SuccessRightRequest {
    readonly type = ActionTypes.SUCCESS_RIGHT_REQUEST;
    constructor(public payload: RightRequest[]) { }
}
export class CreateRightRequest {
    readonly type = ActionTypes.CREATE_RIGHT_REQUEST;
    constructor(public payload: RightRequest) { }
}

export class DeleteRightRequest {
    readonly type = ActionTypes.DELETE_RIGHT_REQUEST;
    constructor(public payload: string) { } // request ID
}

export class ErrorRightRequest {
    readonly type = ActionTypes.ERROR_RIGHT_REQUEST;
}

export class SuccessAllUsers {
    readonly type = ActionTypes.SUCCESS_ALL_USERS;
    constructor(public payload: User[]) { }
}

export class UpdateSpecificRole {
    readonly type = ActionTypes.UPDATE_SPECIFIC_ROLE;
    constructor(public payload: { option: Option, userId: string; }) { }
}
export class SuccessUpdateSpecificRole {
    readonly type = ActionTypes.SUCCESS_UPDATE_SPECIFIC_ROLE;
    constructor(public payload: SpecificRoleDialogData) { }
}
export class ErrorUpdateSpecificRole {
    readonly type = ActionTypes.ERROR_UPDATE_SPECIFIC_ROLE;
}

export class FetchGroups {
    readonly type = ActionTypes.FETCH_GROUPS;
}

export class SuccessFetchGroups {
    readonly type = ActionTypes.SUCCESS_FETCH_GROUPS;
    constructor(public payload: Group[]) { }
}

export class ErrorFetchGroups {
    readonly type = ActionTypes.ERROR_FETCH_GROUPS;
}

export class UpdateGroup {
    readonly type = ActionTypes.UPDATE_GROUP;
    constructor(public payload: {
        group: GroupUpdate;
        users?: User['id'][];
        families?: GroupFamily[];
    }) { }
}
export class SuccessUpdateGroup {
    readonly type = ActionTypes.SUCCESS_UPDATE_GROUP;
    constructor(public payload: Group) { }
}

export class ErrorUpdateGroup {
    readonly type = ActionTypes.ERROR_UPDATE_GROUP;
}

export const transferGroupOwnership = createAction(ActionTypes.TRANSFER_GROUP_OWNERSHIP, props<{ group: Group, transferedTo: User['id'] }>());
export const successTransferGroupOwnership = createAction(ActionTypes.SUCCESS_TRANSFER_GROUP_OWNERSHIP, props<{ group: Group }>());
export const errorTransferGroupOwnership = createAction(ActionTypes.ERROR_TRANSFER_GROUP_OWNERSHIP);

export class CreateGroup {
    readonly type = ActionTypes.CREATE_GROUP;
    constructor(public payload: {
        group: GroupCreate;
        users?: User['id'][];
        families?: GroupFamily[];
    }) { }
}

export class SuccessCreateGroup {
    readonly type = ActionTypes.SUCCESS_CREATE_GROUP;
    constructor(public payload: Group) { }
}

export class ErrorCreateGroup {
    readonly type = ActionTypes.ERROR_CREATE_GROUP;
}

export class DeleteGroup {
    readonly type = ActionTypes.DELETE_GROUP;
    constructor(public payload: { group: Group; }) { }
}

export class SuccessDeleteGroup {
    readonly type = ActionTypes.SUCCESS_DELETE_GROUP;
    constructor(public payload: { groupId: Group['id']; }) { }
}

export class ErrorDeleteGroup {
    readonly type = ActionTypes.ERROR_DELETE_GROUP;
}

export class FetchUsersOfGroup {
    readonly type = ActionTypes.FETCH_USERS_OF_GROUP;
    constructor(public payload: { group: Group; }) { }
}

export class SuccessFetchUsersOfGroup {
    readonly type = ActionTypes.SUCCESS_FETCH_USERS_OF_GROUP;
    constructor(public payload: { group: Group, users: User[]; }) { }
}

export class ErrorFetchUsersOfGroup {
    readonly type = ActionTypes.ERROR_FETCH_USERS_OF_GROUP;
}

export class FetchFamiliesOfGroup {
    readonly type = ActionTypes.FETCH_FAMILIES_OF_GROUP;
    constructor(public payload: { group: Group; }) { }
}

export class SuccessFetchFamiliesOfGroup {
    readonly type = ActionTypes.SUCCESS_FETCH_FAMILIES_OF_GROUP;
    constructor(public payload: { group: Group, families: GroupFamily[]; }) { }
}

export class ErrorFetchFamiliesOfGroup {
    readonly type = ActionTypes.ERROR_FETCH_FAMILIES_OF_GROUP;
}

export class AddUsersToGroup {
    readonly type = ActionTypes.ADD_USERS_TO_GROUP;
    constructor(public payload: { group: Group, users: User['id'][]; }) { }
}

export class SuccessAddUsersToGroup {
    readonly type = ActionTypes.SUCCESS_ADD_USERS_TO_GROUP;
    constructor(public payload: { group: Group, users: User[]; }) { }
}

export class ErrorAddUsersToGroup {
    readonly type = ActionTypes.ERROR_ADD_USERS_TO_GROUP;
}

export class AddFamiliesToGroup {
    readonly type = ActionTypes.ADD_FAMILIES_TO_GROUP;
    constructor(public payload: { group: Group, families: GroupFamily[]; }) { }
}

export class SuccessAddFamiliesToGroup {
    readonly type = ActionTypes.SUCCESS_ADD_FAMILIES_TO_GROUP;
    constructor(public payload: { group: Group, families: GroupFamily[]; }) { }
}

export class ErrorAddFamiliesToGroup {
    readonly type = ActionTypes.ERROR_ADD_FAMILIES_TO_GROUP;
}

export class ChangeGroupFamiliesLevel {
    readonly type = ActionTypes.CHANGE_GROUP_FAMILIES_LEVEL;
    constructor(public payload: { group: Group, families: GroupFamily[]; }) { }
}

export class SuccessChangeGroupFamiliesLevel {
    readonly type = ActionTypes.SUCCESS_CHANGE_GROUP_FAMILIES_LEVEL;
    constructor(public payload: { group: Group, families: GroupFamily[]; }) { }
}

export class ErrorChangeGroupFamiliesLevel {
    readonly type = ActionTypes.ERROR_CHANGE_GROUP_FAMILIES_LEVEL;
}

export class RemoveUsersFromGroup {
    readonly type = ActionTypes.REMOVE_USERS_FROM_GROUP;
    constructor(public payload: { group: Group, users: User['id'][]; }) { }
}

export class SuccessRemoveUsersFromGroup {
    readonly type = ActionTypes.SUCCESS_REMOVE_USERS_FROM_GROUP;
    constructor(public payload: { group: Group, users: User[]; }) { }
}

export class ErrorRemoveUsersFromGroup {
    readonly type = ActionTypes.ERROR_REMOVE_USERS_FROM_GROUP;
}

export class RemoveFamiliesFromGroup {
    readonly type = ActionTypes.REMOVE_FAMILIES_FROM_GROUP;
    constructor(public payload: { group: Group, families: GroupFamily['id'][]; }) { }
}

export class SuccessRemoveFamiliesFromGroup {
    readonly type = ActionTypes.SUCCESS_REMOVE_FAMILIES_FROM_GROUP;
    constructor(public payload: { group: Group, families: GroupFamily[]; }) { }
}

export class ErrorRemoveFamiliesFromGroup {
    readonly type = ActionTypes.ERROR_REMOVE_FAMILIES_FROM_GROUP;
}

export class FetchGroupsOfUser {
    readonly type = ActionTypes.FETCH_GROUPS_OF_USER;
    constructor(public payload: { userId: User['id']; }) { }
}

export class SuccessFetchGroupsOfUser {
    readonly type = ActionTypes.SUCCESS_FETCH_GROUPS_OF_USER;
    constructor(public payload: { group?: Group, requestedGroup?: RequestAGroup; }) { }
}

export class ErrorFetchGroupsOfUser {
    readonly type = ActionTypes.ERROR_FETCH_GROUPS_OF_USER;
}
export class RemoveMyRightsRequest {
    readonly type = ActionTypes.DELETE_MY_RIGHT;
    constructor(public payload: { removeRight: DeleteMyRightsPayload; }) { }
}
export class SuccessDeleteMyRights {
    readonly type = ActionTypes.SUCCESS_DELETE_MY_RIGHT;
    constructor(public payload: { removeRight: DeleteMyRightsPayload; }) { }
}

export class FetchListOfAllGroups {
    readonly type = ActionTypes.FETCH_LIST_OF_ALL_GROUPS;
}

export class SuccessFetchListOfAllGroups {
    readonly type = ActionTypes.SUCCESS_FETCH_LIST_OF_ALL_GROUPS;
    constructor(public payload: { group: Group[]; }) { }
}

export class ErrorFetchListOfAllGroups {
    readonly type = ActionTypes.ERROR_FETCH_LIST_OF_ALL_GROUPS;
}

export class RaiseGroupRequest {
    readonly type = ActionTypes.RAISE_GROUP_REQUEST;
    constructor(public payload: { requestedGroup: SendGroupRequest }) { }
}

export class SuccessRequestedGroup {
    readonly type = ActionTypes.SUCCESS_RAISE_GROUP_REQUEST;
    constructor(public payload: { requestedGroup: RequestAGroup; }) { }
}

export class ErrorCreateGroupOfRequest {
    readonly type = ActionTypes.ERROR_RAISE_GROUP_REQUEST;
}

export class CancelGroupRequest {
    readonly type = ActionTypes.CANCEL_GROUP_REQUEST;
    constructor(public payload: { groupData: Group; }) { }
}

export class SuccessDeleteRequest {
    readonly type = ActionTypes.SUCCESS_CANCEL_GROUP_REQUEST;
    constructor(public payload: { groupData: Group; }) { }
}

export class ErrorCancelGroupRequest {
    readonly type = ActionTypes.ERROR_CANCEL_GROUP_REQUEST;
}

export type Actions = LoadParentFamilyRight |
    FetchMyRightsTree |
    ErrorParentFamilyRight |
    SuccessUserRightTree |
    SuccessMyRightsTree |
    UpdateMyRightsTreeRequestsMapping |
    SuccessManagers |
    CreateRightRequest |
    SuccessRightRequest |
    DeleteRightRequest |
    SuccessUpdateRight |
    ErrorUpdateRight |
    SuccessAllUsers |
    ErrorRightRequest |
    UpdateSpecificRole |
    SuccessUpdateSpecificRole |
    ErrorUpdateSpecificRole |
    FetchGroups |
    SuccessFetchGroups |
    ErrorFetchGroups |
    UpdateGroup |
    SuccessUpdateGroup |
    FetchUsersOfGroup |
    CreateGroup |
    SuccessCreateGroup |
    ErrorCreateGroup |
    SuccessFetchUsersOfGroup |
    ErrorFetchUsersOfGroup |
    FetchFamiliesOfGroup |
    SuccessFetchFamiliesOfGroup |
    ErrorFetchFamiliesOfGroup |
    ErrorUpdateGroup |
    DeleteGroup |
    SuccessDeleteGroup |
    ErrorDeleteGroup |
    AddUsersToGroup |
    SuccessAddUsersToGroup |
    ErrorAddUsersToGroup |
    AddFamiliesToGroup |
    SuccessAddFamiliesToGroup |
    ErrorAddFamiliesToGroup |
    ChangeGroupFamiliesLevel |
    SuccessChangeGroupFamiliesLevel |
    ErrorChangeGroupFamiliesLevel |
    RemoveUsersFromGroup |
    SuccessRemoveUsersFromGroup |
    ErrorRemoveUsersFromGroup |
    RemoveFamiliesFromGroup |
    SuccessRemoveFamiliesFromGroup |
    ErrorRemoveFamiliesFromGroup |
    FetchGroupsOfUser |
    SuccessFetchGroupsOfUser |
    ErrorFetchGroupsOfUser |
    FetchListOfAllGroups |
    SuccessFetchListOfAllGroups |
    ErrorFetchListOfAllGroups |
    SuccessRequestedGroup |
    ErrorCreateGroupOfRequest |
    CancelGroupRequest |
    SuccessDeleteRequest |
    ErrorCancelGroupRequest |
    SuccessDeleteMyRights;

/*export const UpdateSpecificRole = createAction('[UserRight] Update specific role', props<{ payload }>());
export const SuccessUpdateSpecificRole = createAction('[UserRight] Success Update specific role', props<{ payload: SpecificRoleDialogData }>());
export const ErrorUpdateSpecificRole = createAction('[UserRight] Error Update specific role');*/
